import Vue from 'vue';
import Vuex from 'vuex';
import { FieldValue, db } from '@/firebase';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {
    // eslint-disable-next-line no-unused-vars
    async submitForm({ commit }, payload) {
      const serverTimestamp = FieldValue.serverTimestamp();

      await db.collection(`/nataiRegisters`).add({
        ...payload,
        created: serverTimestamp,
        updated: serverTimestamp,
      });
    },
  },
  modules: {},
});
